var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('h3',[_vm._v(" Videos ")]),_c('p',[_vm._v(" What is the total number of videos watched by your passengers? ")]),_c('div',{staticClass:"bar-chart-holder"},[_c('BarChart',{staticClass:"bar-chart",attrs:{"label":"video number","item-data":_vm.itemData,"width":600,"height":300}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }